export enum AssetItemType {
    Normal = 0,
    Directory = 1,
    Project = 2,
    File = 4,
    Link = 8,
    Hotspot = 16,
    PanoramaVersion = 32,
    ProjectMap = 64,
    FileMap = 128,
    StreetMap = 256,
    PanoramaItemLink = 512,
    Navigation = 1024,
    MapArea = 2048,
    Template = 4096,
    PanoramaGroup = 8192,
    SmartObject = 16384
}
